import { render, staticRenderFns } from "./giftManage.vue?vue&type=template&id=6b321a6a&scoped=true&"
import script from "./giftManage.vue?vue&type=script&lang=ts&"
export * from "./giftManage.vue?vue&type=script&lang=ts&"
import style0 from "./giftManage.vue?vue&type=style&index=0&id=6b321a6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b321a6a",
  null
  
)

export default component.exports